import request from '@/utils/request'

// 查询付费标准列表
export function listStandard(query) {
  return request({
    url: '/finance/standard/list',
    method: 'get',
    params: query,
  })
}

// 查询付费标准分页
export function pageStandard(query) {
  return request({
    url: '/finance/standard/page',
    method: 'get',
    params: query,
  })
}

// 查询付费标准详细
export function getStandard(data) {
  return request({
    url: '/finance/standard/detail',
    method: 'get',
    params: data,
  })
}

// 新增付费标准
export function addStandard(data) {
  return request({
    url: '/finance/standard/add',
    method: 'post',
    data: data,
  })
}

// 修改付费标准
export function updateStandard(data) {
  return request({
    url: '/finance/standard/edit',
    method: 'post',
    data: data,
  })
}

// 删除付费标准
export function delStandard(data) {
  return request({
    url: '/finance/standard/delete',
    method: 'post',
    data: data,
  })
}
